var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSnsYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_3805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2709 10.4C26.2709 10.4 26.0463 8.8143 25.3545 8.11801C24.4785 7.2016 23.4992 7.19711 23.05 7.14321C19.8336 6.90961 15.0045 6.90961 15.0045 6.90961H14.9955C14.9955 6.90961 10.1664 6.90961 6.95 7.14321C6.50078 7.19711 5.52148 7.2016 4.64551 8.11801C3.95371 8.8143 3.73359 10.4 3.73359 10.4C3.73359 10.4 3.5 12.2643 3.5 14.1241V15.867C3.5 17.7268 3.7291 19.5911 3.7291 19.5911C3.7291 19.5911 3.95371 21.1768 4.64102 21.8731C5.51699 22.7895 6.66699 22.7581 7.1791 22.8569C9.0209 23.0321 15 23.086 15 23.086C15 23.086 19.8336 23.077 23.05 22.8479C23.4992 22.794 24.4785 22.7895 25.3545 21.8731C26.0463 21.1768 26.2709 19.5911 26.2709 19.5911C26.2709 19.5911 26.5 17.7313 26.5 15.867V14.1241C26.5 12.2643 26.2709 10.4 26.2709 10.4ZM12.6236 17.9829V11.5186L18.8363 14.762L12.6236 17.9829Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_3805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSnsYoutube);
export default __webpack_public_path__ + "static/media/icons-sns-youtube.0e1bf364de5bd17f12d5d2244c7db9ed.svg";
export { ForwardRef as ReactComponent };